export const APPLICANT_SEND_MODALS = {
  sendAnOffer: 'sendAnOffer',
  refuse: 'refuse',
  takeApplicantAsEmployee: 'takeApplicantAsEmployee',
  createEmployeeByQuestionnaire: 'createEmployeeByQuestionnaire',
};
